"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVerificationsEndpoint = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const auth_1 = require("root/src/shared/constants/auth");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const verification_constants_1 = require("root/src/server/gateway/actions/creators/verify/constants/verification.constants");
exports.getVerificationsEndpoint = {
    [endpointIds_1.GET_VERIFICATIONS]: {
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.admin,
        endpointType: lenses_1.otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                userIds: {
                    type: 'array',
                    items: {
                        type: 'string',
                    },
                },
                state: {
                    type: 'string',
                    enum: Object.values(verification_constants_1.verificationStates),
                },
            },
            required: ['state'],
        },
    },
};
